import { createSelector } from 'reselect';
import { getAccommodationTypes, getProperties, getPropertyGroups } from '../../selectors/entitySelectors';

const getCompareIds = state => state.compare.compareListIds || [];
export const getResults = state => state.booking.offers.results;

export const getAccommodationsById = createSelector(
  getAccommodationTypes,
  getCompareIds,
  (accommodations, ids) => ids.map(id => accommodations[id]).reduce((acc, acco) => {
    acc[acco.id] = acco;
    return acc;
  }, {})
);

export const getResultsByCompareIds = createSelector(
  getCompareIds,
  getResults,
  (ids, results) => results.filter(r => ids.includes(r.resource_id)).reduce((acc, r) => {
    acc[r.resource_id] = r;
    return acc;
  }, {})
);

export const getComparablePropertyGroups = (accommodationType, propertyIds) => createSelector(
  getProperties,
  getPropertyGroups,
  (properties, propertyGroups) => propertyIds.map(id => properties[id])
    .reduce((groups, property) => {
      if (!property) return groups;
      if (groups[property.groupId]) {
        groups[property.groupId].properties.push(property);
      } else {
        groups[property.groupId] = {
          ...propertyGroups[property.groupId],
          properties: [property]
        };
      }
      return groups;
    }, {})
);
